import { createContext, useCallback, useContext, useEffect, useState } from "react";
import { useLocation } from "react-router-dom";

import { useAuth } from "@/context/AuthContext";

/*
 * B1 — ONE account, two modes. The mode is pure client-side context:
 * it decides which "home" the user sees, never what they're allowed to do
 * (capabilities are additive — organizers keep every buyer ability).
 * Deep links auto-switch: /dashboard|/builder → organizing, /account → buying.
 */

const STORAGE_KEY = "aos_mode";
const ModeContext = createContext({ mode: "buyer", setMode: () => {}, canOrganize: false });

export const ModeProvider = ({ children }) => {
  const { user } = useAuth();
  const location = useLocation();
  const canOrganize = ["organizer", "admin"].includes(user?.role);
  const [mode, setModeState] = useState(() => localStorage.getItem(STORAGE_KEY) || "buyer");

  const setMode = useCallback((m) => {
    setModeState(m);
    localStorage.setItem(STORAGE_KEY, m);
  }, []);

  useEffect(() => {
    const p = location.pathname;
    if (p.startsWith("/dashboard") || p.startsWith("/builder") || p.startsWith("/create")) {
      setMode("organizer");
    } else if (p.startsWith("/account")) {
      setMode("buyer");
    }
  }, [location.pathname, setMode]);

  return (
    <ModeContext.Provider value={{ mode: canOrganize ? mode : "buyer", setMode, canOrganize }}>
      {children}
    </ModeContext.Provider>
  );
};

export const useMode = () => useContext(ModeContext);
